import { get, post } from '@/tools/http';
import placeholder from '@/assets/images/image_not_found.svg';
import { getImgUrl } from '@/tools/uploader';

const domain = 'event';
const cms = 'cms';

export const events = {
    namespaced: true,

    state: {
        // Events
        events: [],
        eventsCount: null,
        currentEvent: null,
        // Courses
        currentCourses: [],
        finishedCourses: [],
        recomendationCourses: [],
        inviteCourses: [],
        coursesCount: 0,
        // CMS Events
        cmsEvents: [],
        cmsEventsCount: null,
        cmsCurrentEvent: null,

        // Registration
        currentEventParticipationStatus: null,

        // Types
        types: {
            courses: {
                id: 'course',
                cmsKey: 'course',
                name: 'онлайн-курс',
                plural: 'онлайн-курсы',
                genitive: 'онлайн-курса',
                pluralGenitive: 'онлайн-курсов',
                ablative: 'онлайн-курсe',
                completedTitle: 'завершен',
            },
            events: {
                id: 'full_time',
                cmsKey: 'events',
                name: 'очное мероприятие',
                plural: 'очные мероприятия',
                genitive: 'очного мероприятия',
                pluralGenitive: 'очных мероприятий',
                ablative: 'очном мероприятии',
                completedTitle: 'завершено',
            },
            webinars: {
                id: 'webinar',
                cmsKey: 'webinar',
                name: 'вебинар',
                plural: 'вебинары',
                genitive: 'вебинара',
                pluralGenitive: 'вебинаров',
                ablative: 'вебинарe',
                completedTitle: 'завершен',
            },
        },
        subTypes: [],
        competences: [],
        hashTag: '',
    },

    getters: {
        // Events
        getEvents: (state) => state.events,
        getEventsCount: (state) => state.eventsCount,
        getCurrentEvent: (state) => state.currentEvent,
        // Courses
        getCourses: (state) => {
            return [...state.currentCourses, ...state.finishedCourses];
        },
        getInviteCourses: (state) => state.inviteCourses,
        getRecomendationCourses: (state) => state.recomendationCourses,
        getCoursesCount: (state) => state.coursesCount,
        // CMS Events
        getCmsEvents: (state) => state.cmsEvents,
        getCmsEventsCount: (state) => state.cmsEventsCount,
        getCmsCurrentEvent: (state) => state.cmsCurrentEvent,
        getEventId: (state, getters) => (currentType) => {
            switch (currentType) {
                case 'courses':
                    return getters.getCmsCurrentEvent.foreignCourseId;
                case 'events':
                    return getters.getCmsCurrentEvent.foreignEventId;
                case 'webinars':
                    return getters.getCmsCurrentEvent.foreignWebinarId;
                default:
                    return 0;
            }
        },

        // Registration
        getEventParticipationStatus: (state) => state.currentEventParticipationStatus,
        getCanSubscribe: (state) =>
            state.currentEventParticipationStatus &&
            state.currentEventParticipationStatus.canRegister &&
            !state.currentEventParticipationStatus.status,
        getCanUnsubscribe: (state) =>
            state.currentEventParticipationStatus &&
            state.currentEventParticipationStatus.canRegister &&
            state.currentEventParticipationStatus.status === 'subscribed',

        // Types
        getTypes: (state) => state.types,
        getSubTypes: (state) => state.subTypes,
        getSubTypeById: (state) => (id) => {
            return state.subTypes.find((sub) => sub.id === id);
        },
        getSubTypesByType: (state) => (type) => {
            return state.subTypes.filter((sub) => sub.type === type);
        },
        getCompetences: (state) => state.competences,
        getSoftCompetences: (state) => state.competences.filter((el) => el.competenceType === 'soft'),
        getHardCompetences: (state) => state.competences.filter((el) => el.competenceType === 'hard'),
        getHashTag: (state) => state.hashTag,
    },

    mutations: {
        // Events
        setEvents: (state, data) => {
            state.events = data;
        },
        setEventsCount: (state, data) => {
            state.eventsCount = data;
        },
        setCurrentEvent: (state, data) => {
            state.currentEvent = data;
        },
        // Courses
        setCurrentCourses: (state, data) => {
            state.currentCourses = data.map((element) => {
                element.status = 'active';
                return element;
            });
        },
        setFinishedCourses: (state, data) => {
            state.finishedCourses = data.map((element) => {
                element.status = 'finished';
                return element;
            });
        },
        setInviteCourses: (state, data) => {
            state.inviteCourses = data;
        },
        setRecomendationCourses: (state, data) => {
            state.recomendationCourses = data;
        },
        setCoursesCount: (state, data) => {
            state.coursesCount = data;
        },
        // CMS Events
        setCmsEvents: (state, data) => {
            state.cmsEvents = data;
        },
        setCmsEventsCount: (state, data) => {
            state.cmsEventsCount = data;
        },
        setCmsCurrentEvent: (state, data) => {
            state.cmsCurrentEvent = data;
        },

        // Registration
        setCurrentEventParticipationStatus: (state, data) => {
            state.currentEventParticipationStatus = data;
        },

        // Types
        setSubTypes: (state, data) => {
            state.subTypes = data;
        },
        setCompetences(state, items) {
            state.competences = items;
        },

        updateHashTag: (state, tag) => (state.hashTag = tag),
    },

    actions: {
        // Events
        loadCurrentCourses: async (ctx) => {
            ctx.commit('setCurrentCourses', []);
            const path =
                'event/all?filter[status]=public,private&sort[0][column]=statusUpdatedAt&sort[0][order]=DESC&limit=9000&offset=0&filter[type]=course&filter[self]=true&filter[participantStatuses][]=admin_confirmed_request&filter[participantStatuses][]=user_confirmed_request';
            const res = await get(domain, path);
            ctx.commit('setCurrentCourses', res.events || []);
        },
        loadFinishedCourses: async (ctx) => {
            ctx.commit('setFinishedCourses', []);
            const path =
                'event/all?filter[status]=public,private&sort[0][column]=statusUpdatedAt&sort[0][order]=DESC&limit=9999&offset=0&filter[type]=course&filter[self]=true&filter[participantStatuses][]=completed_event&filter[participantStatuses][]=missed_event';
            const res = await get(domain, path);
            ctx.commit('setFinishedCourses', res.events || []);
        },
        loadRecomendationCourses: async (ctx) => {
            ctx.commit('setRecomendationCourses', []);
            const path =
                'event/recommended?sort[0][column]=id&sort[0][order]=DESC&limit=9000&offset=0&filter[type]=course';
            const res = await get(domain, path);
            ctx.commit('setCoursesCount', res.count);
            ctx.commit('setRecomendationCourses', res.events || []);
        },
        loadInviteCourses: async (ctx) => {
            const path =
                'event/all?filter[status]=public,private&sort[0][column]=statusUpdatedAt&sort[0][order]=DESC&limit=9999&offset=0&filter[type]=course&filter[self]=true&filter[participantStatuses][]=admin_sent_request';
            const res = await get(domain, path);
            ctx.commit('setInviteCourses', res.events || []);
        },
        loadAllCourses: async (ctx) => {
            const path =
                'event/all?filter[status]=public,private&sort[0][column]=statusUpdatedAt&sort[0][order]=DESC&limit=9000&offset=0&filter[type]=course&filter[self]=true&filter[participantStatuses][]=admin_confirmed_request&filter[participantStatuses][]=user_confirmed_request&filter[participantStatuses][]=completed_event&filter[participantStatuses][]=missed_event&filter[participantStatuses][]=admin_sent_request&user_participant_dates=1';
            const res = await get(domain, path);
            return res;
        },
        refuseInvite: async (ctx, eventId) => {
            await post('event', 'participant/event/status/to_refused', { event: eventId }, true);
        },
        confirmedInvite: async (ctx, eventId) => {
            await post('event', 'participant/event/status/to_confirmed', { event: eventId }, true);
        },
        fetchEvents: async (
            ctx,
            {
                type = null,
                status = 'all',
                column = 'createdAt',
                order = 'DESC',
                limit = 10,
                offset = 0,
                self = false,
                participantStatus = null,
                pastEvents = null,
                futureEvents = null,
                currentEvents = null,
                willStartInMinutesEvents = null,
                participantStatuses = [],
                datetimeBeginFrom = null,
                foreignCompetenceIds = [],
                foreignCourseAreasId = [],
                ids = [],
                countParticipant = null,
            } = {}
        ) => {
            let url = `event/all?filter[status]=${status}&sort[0][column]=${column}&sort[0][order]=${order}&limit=${limit}&offset=${offset}`;

            if (countParticipant) {
                url += `&count_participants=${countParticipant}`;
            }

            if (type) {
                url += `&filter[type]=${type}`;
            }
            if (self) {
                url += `&filter[self]=${self}`;
            }
            if (participantStatus) {
                url += `&filter[participantStatus]=${participantStatus}`;
            }

            if (pastEvents) {
                url += `&filter[pastEvents]=${pastEvents}`;
            }
            if (futureEvents) {
                url += `&filter[futureEvents]=${futureEvents}`;
            }
            if (currentEvents) {
                url += `&filter[currentEvents]=${currentEvents}`;
            }
            if (willStartInMinutesEvents) {
                url += `&filter[willStartInMinutesEvents]=${willStartInMinutesEvents}`;
            }

            if (participantStatuses && participantStatuses.length) {
                participantStatuses.forEach((status) => {
                    url += `&filter[participantStatuses][]=${status}`;
                });
            }
            if (datetimeBeginFrom) {
                url += `&filter[datetimeBeginFrom]=${datetimeBeginFrom}`;
            }
            if (foreignCompetenceIds.length) {
                foreignCompetenceIds.forEach((id) => {
                    url += `&filter[oneOfCompetenceOrCourseArea][foreignCompetenceIds][]=${id}`;
                });
            }
            if (foreignCourseAreasId.length) {
                foreignCourseAreasId.forEach((id) => {
                    url += `&filter[oneOfCompetenceOrCourseArea][foreignCourseAreasId][]=${id}`;
                });
            }

            if (ids.length) {
                ids.forEach((id) => {
                    url += `&filter[ids][]=${id}`;
                });
            }

            const response = await get(domain, url);

            let preRender = await Promise.all(
                response.events.map(async (event) => {
                    event.preview = await getImgUrl(event.cover ? event.cover.url : '', placeholder);
                    return event;
                })
            );

            ctx.commit('setEvents', preRender);
            ctx.commit('setEventsCount', response.count);

            return response;
        },
        fetchEventById: async (ctx, id) => {
            const response = await get(
                domain,
                `event/all?filter[id]=${id}&filter[status]=all&sort[0][column]=id&sort[0][order]=DESC`
            );

            let event = response.events[0];
            event.preview = await getImgUrl(event.cover ? event.cover.url : '', placeholder);

            ctx.commit('setCurrentEvent', event);
            return event;
        },

        // CMS Events
        fetchCmsEvents: async (
            ctx,
            { type = null, column = 'id', order = 'DESC', limit = 5, offset = 0, status = 'all' } = {}
        ) => {
            let url = `entity/select/${type}?sort[0][column]=${column}&sort[0][order]=${order}&limit=${limit}&offset=${offset}`;
            if (ctx.state.hashTag) {
                url += `&hashtag=${ctx.state.hashTag}`;
            }

            const response = await get(cms, url);

            let preRender = await Promise.all(
                response.list.map(async (event) => {
                    event.preview = await getImgUrl(event.preview, placeholder);
                    return event;
                })
            );

            ctx.commit('setCmsEvents', preRender);
            ctx.commit('setCmsEventsCount', response.count);

            return response;
        },
        fetchCmsEventById: async (ctx, { id = null, type = null }) => {
            const response = await get(cms, `entity/select/${type}?id=${id}`);
            if (response.list.length !== 0) {
                let event = response.list[0];
                event.preview = await getImgUrl(event.preview, placeholder);

                ctx.commit('setCmsCurrentEvent', event);
            }
            return response;
        },

        // Registration
        checkCanRegister: async (ctx, eventId) => {
            const response = await get(domain, `participant/event/selfCheck/${eventId}`);

            ctx.commit('setCurrentEventParticipationStatus', response);
            return response;
        },
        registerParticipant: async (ctx, eventId) => {
            return await post(domain, 'participant/create', { event: eventId }, true);
        },
        updateParticipantStatus: async (ctx, { eventId = null, action = null }) => {
            return await post(domain, `participant/event/status/${action}`, { event: eventId }, true);
        },
        async subscribeToEvent(ctx, { eventId, status = 'subscribed' }) {
            const data = { event: eventId, status };
            return await post('event', 'participant/create', data, true);
        },

        async unsubscribeToEvent(ctx, { eventId }) {
            const data = { event: eventId };
            return await post('event', `participant/event/status/to_unsubscribed`, data, true);
        },

        // Types
        fetchSubTypes: async (ctx) => {
            const response = await get(domain, 'event/subtype/all');

            ctx.commit('setSubTypes', response.eventSubtypes);
            return response.eventSubtypes;
        },

        setHashTag: (ctx, { tag }) => {
            ctx.commit('updateHashTag', tag);
        },

        async loadCompetences({ commit }, programId) {
            commit('setCompetences', []);
            if (!programId) return;
            const answer = await get('progress', `api/v2/programs/${programId}/competences`);
            commit('setCompetences', answer.items);
        },
    },
};
